var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ selected: _vm.selected }},[_c('div',{staticClass:"name pt-2"},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"value pb-2"},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }